import { render, staticRenderFns } from "./editAndDeleteUser.vue?vue&type=template&id=60a3d2f7"
import script from "./editAndDeleteUser.vue?vue&type=script&lang=js"
export * from "./editAndDeleteUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports